// extracted by mini-css-extract-plugin
export default {"agencyOffices":"agencyOffices_vFcJn","title":"title_a7GMU"};